// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"431":"830aec31","453":"c5b40bc1"}[chunkId] + ".chunk.css";
};